import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

import 'stream-chat-react/dist/css/v2/index.css';
import './main.css';

// eslint-disable-next-line @iheartjane/workspace/no-dom-globals-in-module-scope
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
